module.exports = __webpack_public_path__ + "img/c7819075b46f55ea0c077e82e5e44257.png";